import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { sitesForCurrentFactorySelector, isAdminSelector, pathSelector } from '../selectors';
import { createSiteInCurrentFactory, deleteSite, moveSite, updateSite } from '../actions/entry';
import Sites from '../components/Sites';

const mapStateToProps = (state) => {
  const { siteId } = pathSelector(state);
  const isAdmin = isAdminSelector(state);
  const sites = sitesForCurrentFactorySelector(state);

  return {
    items: sites,
    currentId: siteId,
    canEdit: isAdmin,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onCreate: createSiteInCurrentFactory,
      onUpdate: updateSite,
      onMove: moveSite,
      onDelete: deleteSite,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Sites);
